import { useEffect, useState } from "react";

const KEY = "basiq_theme";
const CLS = "theme-dark";

export const getSiteTheme = () => { try { return localStorage.getItem(KEY) === "dark" ? "dark" : "light"; } catch { return "light"; } };

export const applySiteTheme = (theme) => {
  document.documentElement.classList.toggle(CLS, theme === "dark");
  document.documentElement.style.colorScheme = theme;
  try { localStorage.setItem(KEY, theme); } catch {}
  window.dispatchEvent(new CustomEvent("basiq-theme", { detail: theme }));
};

export const useSiteTheme = () => {
  const [theme, setTheme] = useState(getSiteTheme);
  useEffect(() => {
    const on = (e) => setTheme(e.detail);
    window.addEventListener("basiq-theme", on);
    return () => window.removeEventListener("basiq-theme", on);
  }, []);
  const toggle = () => applySiteTheme(theme === "dark" ? "light" : "dark");
  return { theme, toggle, isDark: theme === "dark" };
};
